module.exports = __webpack_public_path__ + "images/notifications-onboarding/action_Illos.b8f2f2899d4fdee8c283.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/notifications-onboarding/action_Illos.svg
// module id = Nvu7
// module chunks = 24